var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9903 21.9921C30.3653 22.3671 30.5759 22.8758 30.5759 23.4061C30.5759 23.9364 30.3653 24.445 29.9903 24.8201L20.8043 34.0061C20.4318 34.3712 19.9301 34.5746 19.4085 34.5719C18.8868 34.5693 18.3873 34.3609 18.0184 33.992C17.6495 33.6231 17.4411 33.1236 17.4385 32.6019C17.4359 32.0803 17.6392 31.5787 18.0043 31.2061L25.8043 23.4061L18.0043 15.6061C17.6392 15.2335 17.4359 14.7319 17.4385 14.2102C17.4411 13.6886 17.6495 13.189 18.0184 12.8202C18.3873 12.4513 18.8868 12.2429 19.4085 12.2403C19.9301 12.2376 20.4318 12.441 20.8043 12.8061L29.9903 21.9921Z",
    fill: "#6B6E76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightLarge);
export default __webpack_public_path__ + "static/media/chevron-right-large.431b80534d3208d74c755fa977a317d8.svg";
export { ForwardRef as ReactComponent };